import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import PropTypes from 'prop-types';

import ButtonBase from 'Buttons/ButtonBase';
import { Icon } from 'Icons';

const TagCloseButton = ({ callback, className }) => (
  <ButtonBase
    aria-label="Close"
    className={`bg-opacity-0 border-opacity-0 leading-none ml-2 p-0 focus:shadow-none focus:border-cyan-3 hover:cursor-pointer hover:text-gray-7 ${className}`}
    onClick={callback}
  >
    <Icon icon={faTimes} />
  </ButtonBase>
);

TagCloseButton.defaultProps = {
  className: '',
};

TagCloseButton.propTypes = {
  callback: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default TagCloseButton;
